import React from "react";
import "./mentor.css";
import OurMentor from "../../Components/OurMentor/OurMentor";
import FAQPage from "../../Components/faq/FAQPage";
import Faq from "../../Components/faq/Faq";
import ourMenterImg from '../../assets/image/ourMenterImg.jpeg'
import { Col, Container, Row } from "react-bootstrap";
import ReactPlayer from "react-player";

const Mentor = () => {
  return (
    <>
      <div className="mentor">
        <div className="menterr_bg" style={{
        backgroundImage: `url(${ourMenterImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "600px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        
        <h2 className="second_heading">Students Chronicle </h2>
        </div>
        <div className="container">
        
        
        </div>
      </div>
      <OurMentor viewMore={true} viewAll={false} />
<Container className="mb-5">

  <h5 className="pre_heading text-center mb-5">Student Health, Fitness & Mental Wellness for Better Focus and Success</h5>
<Row>
  <Col md="4">
   <ReactPlayer
    url={`https://youtube.com/shorts/5tOuR7MJnX0?feature=share`}
  //  light={course?.image}
    playing={true}
    controls
    className="video_player"
  />
  
  </Col>
  <Col md="4">
   <ReactPlayer
    url={`https://youtube.com/shorts/w-EIXeqU8js?feature=share`}
  //  light={course?.image}
    playing={true}
    controls
    className="video_player"
  />
  
  </Col>
  <Col md="4">
   <ReactPlayer
    url={`https://youtube.com/shorts/amxJIiw-phs?feature=share`}
  //  light={course?.image}
    playing={true}
    controls
    className="video_player"
  />
  
  </Col>
</Row>
</Container>



      {/* <Faq /> */}
    </>
  );
};

export default Mentor;
